import Swiper from 'swiper/dist/js/swiper.js'

class Slider {

	constructor (el, options) {
		this.el = el
		this.container = this.el.querySelector('[data-role="js--container"]')
		this.nextButton = this.el.querySelector('[data-role="js--next-slide"]')
		this.previousButton = this.el.querySelector('[data-role="js--previous-slide"]')

		this.paginationEl = this.el.querySelector('[data-role="js--pagination"]')
		// console.log("this.paginationEl",this.paginationEl)

		this.loop = this.el.dataset.loop
		this.autoplay = this.el.dataset.autoplay
		this.tall = this.el.dataset.tall
		this.fraction = this.el.dataset.fraction
		this.free = this.el.dataset.free


		this.properties = {
			wrapperClass: 'swiper-wrapper',
			slideClass: 'swiper-slide',
			slidesPerView: this.tall ? 1 : 4,
			navigation: {
				nextEl: this.nextButton,
				prevEl: this.previousButton
			},
			spaceBetween: this.tall ? 0 : 30,
			pagination: {
				el: this.paginationEl
			},
			initialSlide: 2,
			observer: true,
			observeParents: true,
			breakpoints: {
				768: {
					slidesPerView: this.tall ? 1 : 3,
					spaceBetween: this.tall ? 0 : 10
				},
				640: {
					slidesPerView: this.tall ? 1 : 2,
					spaceBetween: 10
				},
				320: {
					slidesPerView: 1
				}
			}
		}
		if ( this.autoplay ) this.properties.autoplay = {delay: 5000,disableOnInteraction:false}
		if ( this.loop ) this.properties.loop = true
		if ( this.fraction ) {
			this.properties.pagination = {type: "fraction", el: this.paginationEl}
		}
		if ( this.free ) {
			this.properties.freeMode = true
			this.properties.freeModeSticky = true
		}

		// console.log("this.properties",this.properties)
		var swiper = new Swiper(this.container, this.properties)

	}
}

export default Slider
